import { basicInitialState } from '../_utils/basicInitialState';
import { TSessionModel } from './session';

export const sessionInitialState: TSessionModel = {
  ...basicInitialState,
  redirectPath: null,
  user: null
};
